const removeAccents = (str: string) => {
  const accentsMap: { [key: string]: string } = {
    á: 'a',
    é: 'e',
    í: 'i',
    ó: 'o',
    ú: 'u',
    Á: 'A',
    É: 'E',
    Í: 'I',
    Ó: 'O',
    Ú: 'U',
    ñ: 'n',
    Ñ: 'N',
    ç: 'c',
    Ç: 'C',
    // Add more mappings as needed
  }

  return (str ?? '')
    .split('')
    .map((char) => accentsMap[char] || char)
    .join('')
}
export default removeAccents
